import { StatusContainer } from "./styles";

export function StatusTag(props: {color?: string, status?: string}){
    return (
        <StatusContainer className="statusBallContainer">
            <div className={`statusBall ${props.color}`}></div>
            <p>{props.status}</p>
        </StatusContainer>
    )
}